<template>
  <div>
    <h2>Types</h2>
    <h3 class="mt-font--body20">Error</h3>
    <div class="mt--text-right">
      <img :src="error"  />
      <!-- <span @click="handleClickNotiInline" class="demo">demo</span> -->
    </div>
    <h3 class="mt-font--body20">Warning</h3>
    <div class="mt--text-right">
      <img :src="warning"  />
    </div>
    <h3 class="mt-font--body20">Success</h3>
    <div class="mt--text-right">
      <img :src="success"  />
    </div>
    <h3 class="mt-font--body20">Information</h3>
    <div class="mt--text-right">
      <img :src="information"  />
    </div>

  </div>
</template>

<script>
export default {
  name: 'notificationInline',
  props: [],
  components: {

  },
  data () {
    return {
      error: require('@/assets/notification-inline-error.svg'),
      warning: require('@/assets/notification-inline-warning.svg'),
      success: require('@/assets/notification-inline-success.svg'),
      information: require('@/assets/notification-inline-information.svg'),
    }
  },
  computed: {

  },

  methods: {
    handleClickNotiInline(){
      // this.$notiInline('message', 'title', {type: 'warning', actionLabel: 'action', action: () => {
      //   console.log('action')
      // }})
    }
  },
}
</script>

<style lang="scss" scoped>
.demo {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// NotificationInline.vue?35b597a4